<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2025-07-22 09:58:36
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrVideo.vue
-->

<!--视频-->

<template>
  <div class="attr-video">
    <div class="video-item flex-b-c">
      <span class="video-attr">{{$t('PE.Name')}}</span>
      <span class="ellipsis-1" style="font-size: 14px;line-height: 20px;" :title="media.ext_val_name">{{media.ext_val_name}}</span>
    </div>
    <div class="video-item flex-b-c">
      <span class="video-attr">{{$t('PE.Scale')}}</span>
      <el-checkbox v-model="media.ext_val_scaleType">{{$t('PE.ConstrainProportions')}}</el-checkbox>
    </div>

    <div class="video-item flex-b-c">
      <span class="video-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="video-item flex-b-c">
      <span class="video-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>

    <div class="video-item flex-b-c">
      <span class="video-attr">{{$t('PE.VolumeAdjust')}}</span>
      <div style="width: 116px; padding: 0px 12px;">
        <el-slider v-model="media.ext_val_volume" input-size="mini"></el-slider>
      </div>
    </div>
    <div class="video-item flex-b-c">
      <span class="video-attr">{{$t('PE.Duration')}}</span>
      <span>{{msFormatting(media.field_item_playTime)}}</span>
    </div>
    <div class="video-item flex-b-c" v-if="false">
      <span class="video-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import animations from '../../scripts/animations';
import { msFormatting } from "@/assets/scripts/dateFormatting.js";
export default {
  name: "AttrVideo",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      msFormatting,
      animations,
    }
  },
  created() {
    // console.log(this.media);
    // this.media.ext_val_duration = this.media.field_item_playTime / 1000;
  },
  methods: {
    timeFormatting(time) {
      let ms = parseInt(time);
      let H = Math.floor(ms / 1000 / 60 / 60);
      let M = Math.floor(ms / 1000 / 60) % 60;
      let S = Math.ceil(ms / 1000) % 60;
      // let MS = ms % 1000;
      // return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}:${this.formatting(MS, 3)}`;
      return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}`;
    },
    formatting(time, len = 2) {
      let strTime = time + '';
      while (strTime.length < len) {
        strTime = '0' + strTime
      }
      return strTime;
    }
  }
}
</script>

<style lang="scss" scoped>
.attr-video {
  padding-right: 4px;
  .video-item {
    min-height: 36px;
    margin: 8px 0px;
    .video-attr {
      // font-family: "Times New Roman";
      // font-weight: normal;
      // font-stretch: normal;
      // color: #617883;
      min-width: 64px;
    }
  }
}
</style>